import { selector } from 'recoil';

import { PriceUtils } from '@ecp/common/src/utils/price/PriceUtils';
import { DEFAULT_PRICE_FORMAT } from '@ecp/common/src/const/price/priceConst';

import { goodTabInfoState } from '@fo-recoil/good/atom';
import { systemInformationState } from '@fo-recoil/system/atom';
import { goodOptionListState } from './atom';

export const withOptionTotalPrice = selector({
  key: 'withOptionTotalPrice',
  get: ({ get }) => {
    const priceFormat = get(systemInformationState).priceFormat ?? DEFAULT_PRICE_FORMAT;
    const priceUtils = new PriceUtils();
    const selectedOptionList = get(goodOptionListState);

    return selectedOptionList.reduce((sum, curr) => {
      const internalPrice = priceUtils.getDisplayPrice({
        priceFormat,
        price: curr.discountPrice,
        formattedPrice: curr.discountFormattedPrice,
      });

      return sum + internalPrice * curr.count;
    }, 0);
  },
});

export const withGoodTabIndex = selector({
  key: 'withGoodTabIndex',
  get: ({ get }) => {
    return get(goodTabInfoState);
  },
});
